import React from "react";
import { Link } from "react-router-dom";
import EmailContactIcon from "./EmailContactIcon";
import logoGold from "../assets/logo-gold.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-brand">
          <img src={logoGold} alt="" className="footer-logo" />
          <span className="footer-wordmark">EffiGen.AI</span>
        </div>

        <div className="footer-links">
          <Link
            to="/privacy-policy"
            className="privacy-link"
            aria-label="View Privacy Policy"
          >
            Privacy Policy
          </Link>
          <a
            href="https://www.linkedin.com/company/effigen-ai"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Effigen on LinkedIn"
            title="Effigen on LinkedIn"
            className="footer-social"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden
              focusable="false"
            >
              <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.1c.7-1.3 2.4-2.7 5-2.7 5.3 0 6.3 3.5 6.3 8.1V24h-5v-7.9c0-1.9 0-4.3-2.6-4.3s-3 2-3 4.1V24h-5V8z" />
            </svg>
          </a>
          <EmailContactIcon
            subject="Hello from Effigen website"
            body={
              "Hi Effigen team,\n\nI would like to connect with you and explore a business opportunity."
            }
            title="Email Effigen"
            size={18}
            className="footer-social"
          />
        </div>

        <p className="footer-copy">
          &copy; 2025 EffiGen LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
